import ChartBase from "./ChartBase";
import { colors } from "./theme";
export class DonutsTable extends ChartBase {
    constructor() {
        super();
        this.chartElements = [];
        this._init = () => {
            // chart type
            this.chartType = "DonutTableChart";
            // always call this
            this._getElements();
            // get elements
            this.chartContainerElement = this.querySelector(".my-container");
            this.legendElement = this.querySelector(".dashboard-charts-legend");
            this.tableElement = this.querySelector("sva-table");
            // toggle
            this.toggleElement = this.wrapper.querySelector("[data-table-toggle]");
            // check hide/show
            this._updateToggleText();
            // add toggle event
            this.toggleElement.addEventListener("click", (e) => {
                e.preventDefault();
                // toggle
                if (this.hasAttribute("hide-table")) {
                    this.removeAttribute("hide-table");
                }
                else {
                    this.setAttribute("hide-table", '');
                }
                this._updateToggleText();
            });
        };
        this.updateData = (props) => {
            //set metric and question
            this._setBaseInfo(props);
            // get data and labels
            const { chartsData, tableData, backgroundColors } = props;
            // render
            window.customElements.whenDefined('sva-gate-chart').then(() => {
                chartsData.map((chartData, index) => {
                    const wrapper = document.createElement("div");
                    wrapper.className = "col-sm-6 col-md-4";
                    const chartElement = document.createElement("sva-gate-chart");
                    chartElement.setAttribute("large", "");
                    chartElement.setAttribute("no-loading", "");
                    chartElement.setAttribute("noquestion", "");
                    chartElement.setAttribute("ignored", "");
                    chartElement.setAttribute("circle", "");
                    chartElement.setAttribute("reversed", "");
                    chartElement.setAttribute("reversed-legend", "");
                    chartElement.setAttribute("no-legend", "");
                    chartElement.setAttribute("chart-name", `Survey ${index + 1}`);
                    wrapper.appendChild(chartElement);
                    this.chartContainerElement.appendChild(wrapper);
                    this.chartElements.push(chartElement);
                    chartElement.updateData(Object.assign(Object.assign({}, chartData), { metric: "", question: "", backgroundColors: [...(backgroundColors || [])] }));
                });
                // legends
                this._prepareLegend(props);
            });
            window.customElements.whenDefined('sva-table').then(() => {
                this.tableElement.updateData(Object.assign(Object.assign({}, tableData), { metric: "", question: "" }));
            });
            // remove loading
            this.loading = false;
        };
        this._prepareLegend = (props) => {
            let { chartsData, backgroundColors } = props;
            // background colors
            if (!backgroundColors || backgroundColors.length <= 0) {
                backgroundColors = [colors.primary, colors.primaryLight];
            }
            const labels = chartsData[0].labels.reverse();
            for (var i = 0; i < labels.length; i++) {
                const dataId = labels.length - 1 - i;
                // create legend item
                const div = document.createElement("div");
                div.className = "legend-item";
                div.setAttribute("data-id", dataId.toString());
                // create legend
                const spanLegend = document.createElement("span");
                spanLegend.className = "legend-item-color";
                spanLegend.style.backgroundColor = backgroundColors[i];
                // create legend text
                const spanText = document.createElement("span");
                spanText.className = "legend-item-text";
                spanText.textContent = labels[i];
                // add to legend item
                div.appendChild(spanLegend);
                div.appendChild(spanText);
                this.legendElement.appendChild(div);
                // toggle
                div.addEventListener('click', () => {
                    div.classList.toggle("hidden");
                    this.chartElements.map(item => item.dispatchEvent(new CustomEvent('legend-filter', { detail: div.getAttribute("data-id") })));
                });
            }
        };
        this._updateToggleText = () => {
            if (this.hideTable) {
                this.toggleElement.textContent = "Show table";
                this.tableElement.hide();
            }
            else {
                this.toggleElement.textContent = "Hide table";
                this.tableElement.show();
            }
        };
    }
    get hideTable() {
        return this.hasAttribute("hide-table") ? "hide" : "";
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="${this.class} dashboard-charts-item" data-wrapper>
                <div class="d-flex align-items-center mb-3">
                    <h6 class="text-uppercase font-weight-bold mb-0" data-metric></h6>
                    ${!!this.chartName ? `<div class="dashboard-charts-name">${this.chartName}</div>` : ''}
                </div>
                <p class="text-muted-light font-italic dashboard-charts-item-question" data-question></p>
                <div class="row justify-content-center my-container">
                </div>
                <div class="dashboard-charts-legend" data-legend>&nbsp; &nbsp;</div>
                <sva-table no-loading ignored noquestion no-total></sva-table>
                <a href="#" class="dashboard-charts-link py-2 mt-4" data-table-toggle></a>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-donuts-table", DonutsTable);
